/** @prettier */

/**
 * アカウント削除
 */

import {useEffect, useState} from 'react';
import {Container, Box, Stack} from '@mui/material';
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import {useTranslation} from 'react-i18next';

//MTH component import
import {ChkInputTextbox} from '../../component/ChkInputTextbox';
import DeleteDialog from './DeleteAccountDialog';
import {PrimaryButton} from '../../component/BasicButton';
//Style import
import '../../css/common/common.css';

import {useUserInfo} from '../my-site/MainMySite';
import {format} from '../../define';

const DeleteAccount = () => {
  //メールアドレスを取得
  const {email} = useUserInfo();

  const [password, setPassword] = useState(''); //パスワード
  const [authError, setAuthError] = useState(false); //認証エラーフラグ
  const [deleteBtnDisabled, setDeleteBtnDisabled] = useState(true); //Delete Accountボタン非表示フラグ
  const [isOpenDialog, setIsOpenDialog] = useState(false); //ダイアログ表示フラグ
  const [apiWait, setAPIWait] = useState(false); //API応答待ちフラグ

  //TextBoxのエラー状態
  const [passwordError, setPasswordError] = useState(false);

  const trans = useTranslation().t; //翻訳関数

  //入力データのエラーチェック
  useEffect(() => {
    if (password === '' || passwordError) {
      setDeleteBtnDisabled(true);
    } else {
      setDeleteBtnDisabled(false);
    }
  }, [password, passwordError]);

  /**
   * パスワードの確認
   */
  const passwordCheck = () => {
    setDeleteBtnDisabled(true);
    setAPIWait(true);
    setAuthError(false);

    const userPool = new CognitoUserPool({
      UserPoolId:
        process.env.REACT_APP_userPoolId !== undefined
          ? process.env.REACT_APP_userPoolId
          : '',
      ClientId:
        process.env.REACT_APP_userPoolWebClientId !== undefined
          ? process.env.REACT_APP_userPoolWebClientId
          : '',
    });
    const authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });
    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool,
    });
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: () => {
        setIsOpenDialog(true);
        setDeleteBtnDisabled(false);
        setAPIWait(false);
      },
      onFailure() {
        setDeleteBtnDisabled(false);
        setAPIWait(false);
        setAuthError(true);
      },
    });
  };

  return (
    <Container fixed className="accountSetting">
      <Stack spacing={3}>
        {/** タイトル */}
        <Box>
          <h1>{trans('DeleteAccount.title')}</h1>
        </Box>
        <Box>
          <Stack>
            <Box className="accountSetting__text__instruction">
              <h3>{trans('DeleteAccount.instruction')}</h3>
            </Box>
            {/* パスワードが認証されない場合はメッセージを表示 */}
            {authError ? (
              <Box className="accountSetting__text--error">
                {trans('DeleteAccount.errMsg.inputErr')}
              </Box>
            ) : (
              <></>
            )}
            {/* パスワード */}
            <ChkInputTextbox
              setValue={setPassword}
              setError={setPasswordError}
              chkInputTxtOK={format.PASSWORD_PATTERN_OK}
              chkLength={format.PASSWORD_LENGTH_MAX}
              type="password"
              label={trans('DeleteAccount.txtField.label.password')}
              value={password}
              id="mv-loginPasswordInputBox"
              class="accountSetting__textBox--password"
              helperText=" "
              errHelperText={trans('DeleteAccount.txtField.errHelperTxt')}
              variant="standard"
              autoFocus={true}
            />
            {/* 認証ボタン */}
            <Box className="accountSetting__button">
              <PrimaryButton
                onClick={passwordCheck}
                buttonText={trans('DeleteAccount.buttonTxt.deleteAccount')}
                id="mv-deleteAccountBtn"
                disabled={deleteBtnDisabled}
                apiWait={apiWait}
              />
            </Box>
          </Stack>
        </Box>
      </Stack>
      {/* 削除確認ダイアログ */}
      <DeleteDialog
        isOpenDeleteDialog={isOpenDialog}
        setIsOpenDeleteDialog={setIsOpenDialog}
        emailAddr={email}
      />
    </Container>
  );
};
export default DeleteAccount;
